import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {NgModel} from '@angular/forms';

@Component({
  selector: 'app-players-page-search',
  templateUrl: './players-page-search.component.html',
  styleUrls: ['./players-page-search.component.scss']
})
export class PlayersPageSearchComponent implements OnInit {

  @Output() changeEmitter = new EventEmitter<string>();
  private changedValue;
  constructor() { }

  ngOnInit(): void {
  }

  onChangeEmitter(typedValue) {
    this.setChangedValue(typedValue);
    this.changeEmitter.emit(typedValue);
  }

  getChangedValue() {
    return this.changedValue;
  }

  setChangedValue(value) {
    this.changedValue = value;
  }

}
